export default __webpack_public_path__ + "static/media/no_poster-placeholder.1d6f79cc.png";